export default "__VITE_ASSET__C1XiK522__"